<div class="staff-setup">
  <div class="staff-heading">
    <div>
      <span class="staff-kicker"> Step 3 </span>

      <h3>Match your staff</h3>

      <p>
        Connect Square team members with gloget staff. Square staff who can
        receive appointments are identified separately from ordinary team
        members.
      </p>
    </div>
  </div>

  <div *ngIf="successMessage" class="staff-notice staff-notice--success">
    {{ successMessage }}
  </div>

  <div *ngIf="errorMessage" class="staff-notice staff-notice--error">
    {{ errorMessage }}
  </div>

  <!-- Square staff -->

  <section class="staff-section">
    <div class="staff-section__header">
      <div>
        <h4>Square team members</h4>

        <p>Match Square employees with their gloget staff records.</p>
      </div>

      <span class="count-pill">
        {{ squareStaff.length }}
      </span>
    </div>

    <div *ngIf="squareStaff.length === 0" class="empty-state">
      No active Square team members were found.
    </div>

    <div class="staff-list">
      <article
        *ngFor="let member of squareStaff"
        class="staff-card"
        [class.staff-card--mapped]="!!member.mapping"
      >
        <div class="staff-card__main">
          <div class="source-badge source-badge--square">Square</div>

          <div class="staff-card__identity">
            <div class="staff-title-row">
              <h5>
                {{ member.display_name }}
              </h5>

              <span *ngIf="member.is_bookable" class="bookable-pill">
                Bookable
              </span>

              <span *ngIf="!member.is_bookable" class="setup-pill">
                Needs Appointments setup
              </span>

              <span *ngIf="member.mapping" class="mapped-pill"> ✓ Mapped </span>
            </div>

            <p *ngIf="member.email_address">
              {{ member.email_address }}
            </p>

            <small *ngIf="member.phone_number">
              {{ member.phone_number }}
            </small>
          </div>
        </div>

        <!-- mapped -->

        <div *ngIf="member.mapping" class="mapped-result">
          <div>
            <span> Connected to </span>

            <strong>
              {{ member.mapping.staff_name }}
            </strong>
          </div>

          <small>
            {{ member.mapping.salon_name }}
          </small>
        </div>

        <!-- unmapped -->

        <div *ngIf="!member.mapping" class="staff-actions">
          <div class="map-existing">
            <label> Map to existing gloget staff </label>

            <div class="map-existing__controls">
              <select [(ngModel)]="selectedStaffBySquareMember[member.id]">
                <option value="">Select staff member</option>

                <option
                  *ngFor="let staff of availableStaffFor(member)"
                  [value]="staff.id"
                >
                  {{ staff.salon.name }}
                  —
                  {{ staff.name }}
                </option>
              </select>

              <button
                type="button"
                class="map-button"
                [disabled]="mappingTeamMemberId === member.id"
                (click)="mapExisting(member)"
              >
                {{ mappingTeamMemberId === member.id ? "Mapping..." : "Map" }}
              </button>
            </div>
          </div>

          <div class="action-divider">or</div>

          <button
            type="button"
            class="create-button"
            (click)="openCreateInGloget(member)"
          >
            Create new staff in gloget
          </button>
        </div>
      </article>
    </div>
  </section>

  <!-- gloget-only -->

  <section class="staff-section">
    <div class="staff-section__header">
      <div>
        <h4>gloget-only staff</h4>

        <p>These staff members have not been mapped to a Square team member.</p>
      </div>

      <span class="count-pill">
        {{ unmappedGlogetStaff.length }}
      </span>
    </div>

    <div
      *ngIf="unmappedGlogetStaff.length === 0"
      class="empty-state empty-state--success"
    >
      ✓ All gloget staff are mapped to Square.
    </div>

    <div class="staff-list">
      <article *ngFor="let staff of unmappedGlogetStaff" class="staff-card">
        <div class="staff-card__main">
          <div class="source-badge source-badge--gloget">gloget</div>

          <div class="staff-card__identity">
            <h5>
              {{ staff.name }}
            </h5>

            <p>
              {{ staff.email }}
            </p>

            <small>
              {{ staff.salon.name }}
            </small>
          </div>
        </div>

        <div class="gloget-only-actions">
          <span> No Square team member mapped </span>

          <button
            type="button"
            class="create-square-button"
            [disabled]="creatingSquareStaffId === staff.id"
            (click)="createInSquare(staff)"
          >
            {{
              creatingSquareStaffId === staff.id
                ? "Creating..."
                : "Create team member in Square"
            }}
          </button>
        </div>
      </article>
    </div>
  </section>

  <!-- modal -->

  <div
    *ngIf="showCreateGlogetModal"
    class="modal-backdrop"
    (click)="closeCreateGlogetModal()"
  >
    <div
      class="create-modal"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()"
    >
      <div class="create-modal__header">
        <div>
          <span class="modal-kicker"> Square → gloget </span>

          <h3>Create staff in gloget</h3>

          <p>
            Review the Square employee information and assign the staff member
            to a gloget salon.
          </p>
        </div>

        <button
          type="button"
          class="modal-close"
          [disabled]="createGlogetSubmitting"
          (click)="closeCreateGlogetModal()"
        >
          ×
        </button>
      </div>

      <div
        *ngIf="createGlogetError"
        class="staff-notice staff-notice--error modal-error"
      >
        {{ createGlogetError }}
      </div>

      <div class="modal-form">
        <div class="form-field">
          <label> gloget salon * </label>

          <select [(ngModel)]="createGlogetForm.salon_id">
            <option value="">Select salon</option>

            <option *ngFor="let salon of glogetSalons" [value]="salon.id">
              {{ salon.name }}
            </option>
          </select>
        </div>

        <div class="modal-form__grid">
          <div class="form-field">
            <label> First name * </label>

            <input type="text" [(ngModel)]="createGlogetForm.first_name" />
          </div>

          <div class="form-field">
            <label> Last name * </label>

            <input type="text" [(ngModel)]="createGlogetForm.last_name" />
          </div>
        </div>

        <div class="form-field">
          <label> Email * </label>

          <input type="email" [(ngModel)]="createGlogetForm.email" />
        </div>

        <div class="modal-form__grid">
          <div class="form-field">
            <label> Phone </label>

            <input type="tel" [(ngModel)]="createGlogetForm.phone_number" />
          </div>

          <div class="form-field">
            <label> Job title </label>

            <input
              type="text"
              [(ngModel)]="createGlogetForm.job_title"
              placeholder="Stylist"
            />
          </div>
        </div>

        <p class="import-note">
          An account will be created for this staff member without a usable
          password. You can add your normal staff invitation/password setup flow
          later.
        </p>
      </div>

      <div class="create-modal__footer">
        <button
          type="button"
          class="modal-cancel-button"
          [disabled]="createGlogetSubmitting"
          (click)="closeCreateGlogetModal()"
        >
          Cancel
        </button>

        <button
          type="button"
          class="modal-submit-button"
          [disabled]="createGlogetSubmitting"
          (click)="submitCreateInGloget()"
        >
          {{ createGlogetSubmitting ? "Creating..." : "Create & map staff" }}
        </button>
      </div>
    </div>
  </div>
</div>
